export default __webpack_public_path__ + "8632c35aaf985cddbfa5853ce680202f.png";